module.exports = __webpack_public_path__ + "img/3.07173a04.png";